(function () {
  'use strict';

  var sealPlans = new WeakMap();

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function getRoots(scope) {
    var context = scope || document;
    if (context.matches && context.matches('.dbe-product-redesign')) return [context];
    return toArray(context.querySelectorAll ? context.querySelectorAll('.dbe-product-redesign') : []);
  }

  function getProductData(root) {
    var node = root.querySelector('.product-json');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, data) {
    if (window.theme && theme.Helpers && typeof theme.Helpers.formatMoney === 'function') {
      return theme.Helpers.formatMoney(
        cents,
        data && data.money_format
          ? data.money_format
          : '€{{amount_with_comma_separator}}'
      );
    }

    return (Number(cents || 0) / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function currentVariant(root, data) {
    if (!data || !data.variants) return null;

    var input = root.querySelector('.formVariantId[name="id"], .formVariantId');
    var id = input ? String(input.value || '') : '';

    return data.variants.find(function (variant) {
      return String(variant.id) === id;
    }) || data.variants[0] || null;
  }

  function readSellingPlanId(root) {
    var seal = root.querySelector('.sealsubs-target-element');
    if (!seal) return '';

    var checked = seal.querySelector('input[name="selling_plan"]:checked');
    if (checked) return String(checked.value || '').trim();

    var input = seal.querySelector(
      '[data-sls-selling_plan][name="selling_plan"], input[name="selling_plan"], select[name="selling_plan"]'
    );

    return input ? String(input.value || '').trim() : '';
  }

  function selectedSellingPlanId(root) {
    return sealPlans.has(root)
      ? sealPlans.get(root)
      : readSellingPlanId(root);
  }

  function effectiveOneTimePrice(data, variant) {
    if (!variant || typeof variant.price !== 'number') return null;

    return data && data.product_of_the_month
      ? Math.round(variant.price * 0.9)
      : variant.price;
  }

  function subscriptionPrice(root, variant) {
    if (!variant) return null;

    var planId = selectedSellingPlanId(root);
    if (!planId) return null;

    var allocations = variant.selling_plan_allocations || [];
    var allocation = allocations.find(function (item) {
      var itemPlanId =
        item.selling_plan_id ||
        (item.selling_plan && item.selling_plan.id);

      return String(itemPlanId || '') === String(planId);
    });

    if (!allocation && allocations.length === 1) {
      allocation = allocations[0];
    }

    return allocation && typeof allocation.price === 'number'
      ? allocation.price
      : null;
  }

  function updateDisplayedPrice(root, data) {
    var variant = currentVariant(root, data);
    var cents = subscriptionPrice(root, variant);

    toArray(root.querySelectorAll('[data-price]')).forEach(function (box) {
      var group = box.querySelector('.price__pricing-group') || box;
      var custom = group.querySelector('.dbe-subscription-price');

      if (cents === null) {
        box.classList.remove('dbe-price--subscription');
        if (custom) custom.remove();
        return;
      }

      if (!custom) {
        custom = document.createElement('span');
        custom.className = 'dbe-subscription-price';
        custom.setAttribute('aria-live', 'polite');
        group.appendChild(custom);
      }

      custom.textContent = formatMoney(cents, data);
      box.classList.add('dbe-price--subscription');
    });

    updateLoyaltyPoints(root, cents, variant, data);
  }

  function parseWholeEuroPrice(value) {
    var numeric = (value || '')
      .replace(/\u00a0/g, ' ')
      .trim()
      .replace(/[^0-9.,]/g, '');

    if (!numeric) return '';

    if (numeric.indexOf(',') !== -1) {
      return numeric.split(',')[0].replace(/\./g, '');
    }

    if (numeric.indexOf('.') !== -1) {
      var parts = numeric.split('.');
      if (parts[parts.length - 1].length === 2) parts.pop();
      return parts.join('').replace(/,/g, '');
    }

    return numeric.replace(/[.,]/g, '');
  }

  function updateLoyaltyPoints(root, subscriptionCents, variant, data) {
    var target = root.querySelector('[data-dbe-loyalty-points]');
    if (!target) return;

    var oneTimeCents = effectiveOneTimePrice(data, variant);
    var points =
      subscriptionCents !== null && subscriptionCents !== undefined
        ? String(Math.floor(subscriptionCents / 100))
        : oneTimeCents !== null
          ? String(Math.floor(oneTimeCents / 100))
          : '';

    if (!points) {
      var price = root.querySelector('.product-blocks__block--price .price-item');
      points = price ? parseWholeEuroPrice(price.textContent) : '';
    }

    if (points && target.textContent.trim() !== points) {
      target.textContent = points;
    }
  }

  function updateSealOneTimePrice(root, data) {
    if (!data || !data.product_of_the_month) return;

    var seal = root.querySelector('.sealsubs-target-element');
    var variant = currentVariant(root, data);
    var cents = effectiveOneTimePrice(data, variant);

    if (!seal || cents === null) return;

    var price = seal.querySelector(
      '.sls-one-time-price .sls-price > .money, .sls-one-time-price .sls-price > span'
    );

    if (price) price.textContent = formatMoney(cents, data);
  }


  function updateTitleBadge(root, data) {
    var badge = root.querySelector('[data-dbe-title-badge]');
    if (!badge) return;
    var isPdm = badge.getAttribute('data-dbe-product-of-month') === 'true';
    var isEnglish = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    badge.textContent = isPdm ? (isEnglish ? 'Product of the month' : 'Produkt des Monats') : 'Bestseller';
    badge.classList.toggle('dbe-product-title-badge--pdm', isPdm);
  }
  function refineRating(root) {
    var isEnglish = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var found = false;

    root.querySelectorAll('.dbe-product-rating .jdgm-prev-badge, .dbe-product-rating .jdgm-preview-badge').forEach(function (badge) {
      var count = badge.getAttribute('data-number-of-reviews') || badge.getAttribute('data-review-count') || '';
      var text = badge.querySelector('.jdgm-prev-badge__text, .jdgm-preview-badge__text');

      if (!count && text) {
        var match = (text.textContent || '').match(/\d[\d.,]*/);
        count = match ? match[0] : '';
      }
      if (!count) {
        var match2 = (badge.textContent || '').match(/\d[\d.,]*/);
        count = match2 ? match2[0] : '';
      }
      if (!count) return;

      found = true;
      var next = isEnglish ? '(' + count + ' reviews)' : '(' + count + ' Bewertungen)';

      if (text) {
        if (text.textContent.trim() !== next) text.textContent = next;
      } else {
        var span = document.createElement('span');
        span.className = 'jdgm-prev-badge__text dbe-rating-count-text';
        span.textContent = next;
        badge.appendChild(span);
      }
    });

    return found;
  }

  function observeRating(root) {
    var target = root.querySelector('.dbe-product-rating');
    if (!target) return;
    refineRating(root);
    var observer = new MutationObserver(function () { refineRating(root); });
    observer.observe(target, { childList: true, subtree: true, characterData: true, attributes: true });
    window.setTimeout(function () { refineRating(root); }, 350);
    window.setTimeout(function () { refineRating(root); }, 1200);
  }

  function refineEmptyReviews() {
    document.querySelectorAll('.jdgm-review-widget, .jdgm-widget, .jdgm-carousel-wrapper').forEach(function(widget) {
      var walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var value = (node.nodeValue || '').trim();
        if (/Kundenstimmenvideo schicken|send.*review.*video/i.test(value)) {
          node.nodeValue = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? 'No reviews yet.' : 'Noch keine Bewertungen.';
        }
      }
    });
  }

  function refreshGallery(root) {
    var main = root.querySelector('.js-carousel-main');
    if (!main) return;

    root
      .querySelectorAll('.dbe-product-gallery .product__image')
      .forEach(function (image) {
        image.style.visibility = 'visible';
        image.style.opacity = '1';
      });

    window.requestAnimationFrame(function () {
      var instance =
        window.Flickity && window.Flickity.data
          ? window.Flickity.data(main)
          : null;

      if (instance) {
        instance.resize();
        instance.reposition();
      }
    });
  }

  function refineSubscriptionDetails(root, block) {
    var intro = root.dataset.dbeSubscriptionDetailsIntro;
    var discountNote = root.dataset.dbeSubscriptionDetailsDiscountNote;
    if (!intro || !discountNote) return;

    block.querySelectorAll('.sls-subscription-details-label a').forEach(function (link) {
      if (!link.classList.contains('dbe-subscription-details-link')) {
        link.style.setProperty('--dbe-subscription-details-base-size', window.getComputedStyle(link).fontSize);
        link.classList.add('dbe-subscription-details-link');
      }
    });

    block.querySelectorAll('.sls-more-info-popup-content').forEach(function (popup) {
      var heading = popup.querySelector('strong');
      var moreLink = popup.querySelector('a');
      if (heading && heading.textContent !== intro) heading.textContent = intro;
      if (!moreLink) return;

      var note = popup.querySelector('.dbe-subscription-details-discount-note');
      if (!note) {
        note = document.createElement('span');
        note.className = 'dbe-subscription-details-discount-note';
      }
      if (note.textContent !== discountNote) note.textContent = discountNote;
      if (note.nextSibling !== moreLink) moreLink.parentNode.insertBefore(note, moreLink);
    });
  }

  function observeSubscriptionDetails(root) {
    // Only main-product passes the popup copy; other PDP templates keep Seal's text.
    if (!root.dataset.dbeSubscriptionDetailsIntro) return;
    var block = root.querySelector('.shopify-app-block[id*="seal_subscriptions"]') ||
      root.querySelector('.dbe-product-blocks') || root;
    var options = { childList: true, subtree: true };
    var observer = new MutationObserver(function () {
      observer.disconnect();
      refineSubscriptionDetails(root, block);
      observer.observe(block, options);
    });
    refineSubscriptionDetails(root, block);
    observer.observe(block, options);
  }

  function refreshPrices(root) {
    var data = getProductData(root);
    if (!data) return;

    updateDisplayedPrice(root, data);
    updateSealOneTimePrice(root, data);
    updateTitleBadge(root, data);
  }

  function rootFromSealEvent(event) {
    var detail = event && event.detail ? event.detail : {};
    var element = detail.element || (event ? event.target : null);

    return element && element.closest
      ? element.closest('.dbe-product-redesign')
      : null;
  }

  var sealDefaults = new WeakSet();

  function hasSellingPlans(data) {
    return toArray(data && data.variants).some(function (variant) {
      return variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0;
    });
  }

  function defaultSixWeekSubscription(root) {
    if (sealDefaults.has(root)) return;
    if (new URLSearchParams(window.location.search).has('selling_plan')) {
      sealDefaults.add(root);
      return;
    }

    var widget = root.querySelector('.sealsubs-target-element');
    if (!widget) return;

    var groups = toArray(widget.querySelectorAll('.sls-option-container[data-selling-plan-group]'));
    var match = groups.map(function (group) {
      var select = group.querySelector('select[name="subs_interval"]');
      var option = select && toArray(select.options).find(function (item) {
        return !item.disabled && /(?:^|\s)6\s*(?:Wochen?|weeks?)\b/i.test(item.textContent || '');
      });
      var radio = group.querySelector('input[data-type="subscription"]');
      return option && radio && !radio.disabled ? { select: select, option: option, radio: radio } : null;
    }).find(function (item) { return item; });

    if (!match) return;
    sealDefaults.add(root);
    match.select.value = match.option.value;
    match.select.dispatchEvent(new Event('change', { bubbles: true }));
    match.radio.click();
    sealPlans.delete(root);
    refreshPrices(root);
  }

  // Seal renders its widget asynchronously, so watch for it, but stop for good once
  // the default is applied, the shopper picks anything themselves (a Tab keypress
  // is not a choice, so only click/change count), or the widget never offers a
  // 6-week plan within the deadline.
  function observeSubscriptionDefault(root) {
    var block = root.querySelector('.dbe-product-blocks') || root;
    var observer = new MutationObserver(attempt);
    var deadline = window.setTimeout(finish, 10000);

    function finish() {
      sealDefaults.add(root);
      observer.disconnect();
      window.clearTimeout(deadline);
      ['click', 'change'].forEach(function (type) {
        block.removeEventListener(type, onShopperInput, true);
      });
    }

    function onShopperInput(event) {
      if (event.isTrusted) finish();
    }

    function attempt() {
      defaultSixWeekSubscription(root);
      if (sealDefaults.has(root)) finish();
    }

    ['click', 'change'].forEach(function (type) {
      block.addEventListener(type, onShopperInput, true);
    });
    observer.observe(block, { childList: true, subtree: true });
    attempt();
  }

  function initRoot(root) {
    if (root.dataset.dbeProductV12 === 'true') return;
    root.dataset.dbeProductV12 = 'true';

    var data = getProductData(root);
    if (!data) return;

    updateDisplayedPrice(root, data);
    updateSealOneTimePrice(root, data);
    updateTitleBadge(root, data);
    observeRating(root);
    if (hasSellingPlans(data)) {
      observeSubscriptionDefault(root);
      observeSubscriptionDetails(root);
    }
    refineEmptyReviews();
    refreshGallery(root);

    root.addEventListener('change', function (event) {
      if (event.target.matches('.formVariantId')) {
        refreshPrices(root);
      }
    });
  }

  function init(scope) {
    getRoots(scope).forEach(initRoot);
  }

  document.addEventListener('sealsubs:subscription_widget_created', function (event) {
    var root = rootFromSealEvent(event);

    if (root) {
      sealPlans.delete(root);
      refreshPrices(root);
      return;
    }

    getRoots(document).forEach(function (item) {
      sealPlans.delete(item);
      refreshPrices(item);
    });
  });

  document.addEventListener('sealsubs:selling_plan_changed', function (event) {
    var root = rootFromSealEvent(event);
    if (!root) return;

    var detail = event.detail || {};
    sealPlans.set(root, String(detail.selling_plan_id || '').trim());
    refreshPrices(root);
  });

  document.addEventListener('sealsubs:price_update', function (event) {
    var root = rootFromSealEvent(event);

    if (root && !sealPlans.has(root)) {
      var livePlanId = readSellingPlanId(root);
      if (livePlanId) sealPlans.set(root, livePlanId);
    }

    (root ? [root] : getRoots(document)).forEach(refreshPrices);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Prevent JS-control links with href="#" from jumping product pages to the top.
  document.addEventListener('click', function (event) {
    var close = event.target && event.target.closest
      ? event.target.closest('.dbe-product-redesign .sls-more-info-popup > .sls-close') : null;
    if (close) {
      var info = close.closest('.sls-more-info-text');
      if (info) info.classList.remove('sls-show-tab', 'sls-show');
      // Capture phase: keep Seal's own handler (and any href) from re-acting on this click.
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    var anchor = event.target && event.target.closest ? event.target.closest('a[href="#"]') : null;
    if (!anchor) return;
    event.preventDefault();
  }, true);

  var dbeReviewMount = document.querySelector('main') || document.body;
  if (dbeReviewMount && 'MutationObserver' in window) {
    var dbeEmptyReviewObserver = new MutationObserver(refineEmptyReviews);
    dbeEmptyReviewObserver.observe(dbeReviewMount, { childList: true, subtree: true });
    window.setTimeout(function () {
      refineEmptyReviews();
      dbeEmptyReviewObserver.disconnect();
    }, 5000);
  }
  window.setTimeout(refineEmptyReviews, 600);
  window.setTimeout(refineEmptyReviews, 1800);

})();
